
import { withAsync } from './withAsync';
import { SelectWidget } from './Select';
import { SelectMultipleWidget } from './SelectMultiple';

export const AsyncSelectWidget = withAsync(SelectWidget);
export const AsyncSelectMultipleWidget = withAsync(SelectMultipleWidget);
